var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOdt = function SvgOdt(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "90px",
    viewBox: "0 0 71 90",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "odt-ico")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.0909091,-6.80022355e-15 L51.411377,-3.71749449e-15 L65.375,14.668216 L65.375,75.9090909 C65.375,78.1684376 63.5434376,80 61.2840909,80 L10.0909091,80 C7.83156239,80 6,78.1684376 6,75.9090909 L6,4.09090909 C6,1.83156239 7.83156239,-4.02585684e-15 10.0909091,-4.4408921e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.3%",
    y: "-8.1%",
    width: "128.6%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "51.625 0 65.588623 14.4848633 51.625 14.4848633"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.5%",
    y: "-38.0%",
    width: "193.1%",
    height: "189.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIDE-Kit-Copy-2",
    transform: "translate(-5373.000000, -1180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "odt-ico",
    transform: "translate(5373.000000, 1183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    strokeWidth: 1,
    d: "M64.875,14.8681527 L51.1970266,0.5 L10.0909091,0.5 C8.10770476,0.5 6.5,2.10770476 6.5,4.09090909 L6.5,75.9090909 C6.5,77.8922952 8.10770476,79.5 10.0909091,79.5 L61.2840909,79.5 C63.2672952,79.5 64.875,77.8922952 64.875,75.9090909 L64.875,14.8681527 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeWidth: 1,
    d: "M52.125,1.23908949 L52.125,13.9848633 L64.412115,13.9848633 L52.125,1.23908949 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    id: ".odt",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: 16.3636364,
    fontWeight: 500,
    fill: "#4F5E65"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.1768643,
    y: 68.9090909
  }, ".odt")), /*#__PURE__*/React.createElement("g", {
    id: "microsoft-word-copy-2",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2B579A",
    fillRule: "nonzero",
    points: "28.0240395 33.7242758 56 33.7242758 56 31.6667583 28 31.6667583 28 29.1487349 55.9759605 29.1487349 55.9759605 27.0941694 28.0180296 27.0941694 28.0180296 24.5554822 55.9939901 24.5554822 55.9939901 22.5245325 28.0180296 22.5245325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,19 C30.2532949,19 26,14.7467051 26,9.5 C26,4.25329488 30.2532949,0 35.5,0 C40.7467051,0 45,4.25329488 45,9.5 C45,14.7467051 40.7467051,19 35.5,19 Z M35.5,15 C38.5375661,15 41,12.5375661 41,9.5 C41,6.46243388 38.5375661,4 35.5,4 C32.4624339,4 30,6.46243388 30,9.5 C30,12.5375661 32.4624339,15 35.5,15 Z",
    id: "Oval-13",
    fill: "#2B579A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#2B579A",
    fillRule: "nonzero",
    points: "22 1.00458838 22 35.7569444 0 32.1458929 0 4.71658416 22 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(11.000000, 18.000000) scale(1, -1) translate(-11.000000, -18.000000) translate(7.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.43081758,7.34356948 C3.37255892,7.26697423 4.29238878,7.08051267 4.86434586,8.11502725 C5.29670204,8.89558071 5.26033352,10.3219279 4.75885457,10.9217644 C4.1103203,11.6972913 3.27248902,11.5867069 2.43081758,11.4454844 L2.43081758,7.34356948 Z M2.3644055,0 L0,0 L0,13.9838988 C1.82407322,13.9838988 3.6388849,14.0382336 5.44691984,13.9472767 C5.92219539,13.9233407 6.47404813,13.5489814 6.8248575,13.1650478 C8.16755611,11.6960945 8.167782,9.86618613 7.76659884,8.04106497 C7.40901272,6.41557017 6.4193824,5.27190736 4.85960214,4.8697823 C4.08253565,4.66943786 3.25102933,4.70629932 2.3644055,4.62898599 L2.3644055,0 Z",
    id: "path30"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-25",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 25,
    y: 21,
    width: 21,
    height: 4
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOdt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/odt.bff37c81.svg";
export { ForwardRef as ReactComponent };